module.exports = __webpack_public_path__ + "assets/img/00193.7037dcde.png";